module.exports = __webpack_public_path__ + "img/titel1.0fa19c4a.webp";